var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[(_vm.header)?_c('div',{staticClass:"card-header"},[_vm._t("card-header")],2):_vm._e(),(!_vm.noBody)?_c('div',{staticClass:"card-body"},[_vm._t("card-body")],2):_vm._e(),(_vm.footer)?_c('div',{staticClass:"card-footer text-muted"},[_vm._t("card-footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }